$mol_icon_play $mol_icon path \M8,5.14V19.14L19,12.14L8,5.14Z
